import { Chip } from "@mui/material"
import type { ColumnDef } from "@tanstack/react-table"
import React from "react"

import FileChip from "@/components/upload/components/display/FileChip"
import type { FieldGroupEnum, SignedUrl } from "@/graphql/codegen/graphql"
import { PurchaseOrderFileRowActions } from "@/screens/Procurement/PurchaseOrder/components/PurchaseOrderFiles/tables/PurchaseOrderFileRowActions"
import { PURCHASE_ORDER_FILE_TYPE_TO_LABEL } from "@/screens/Procurement/PurchaseOrder/constants"
import colors from "@/styles/colors"

export const usePurchaseOrderFilesColumns = ({
  onRemove,
  isReadonly = false,
}: {
  onRemove: (fileId: string) => Promise<void>
  isReadonly?: boolean
}): ColumnDef<SignedUrl>[] => {
  return [
    {
      accessorKey: "fileType",
      header: "Type",
      enableSorting: true,
      sortingFn: "alphanumeric",
      size: 100,
      cell: ({ row }) => {
        const fieldGroup = row.original.file?.fieldGroup as FieldGroupEnum

        return (
          <Chip
            className='mr-2 rounded-full'
            label={PURCHASE_ORDER_FILE_TYPE_TO_LABEL.get(fieldGroup) ?? "Other"}
            sx={{
              backgroundColor: colors.tertiary.yellow["300"],
            }}
          />
        )
      },
    },
    {
      accessorKey: "file",
      header: "File",
      enableSorting: false,
      sortingFn: "alphanumeric",
      size: 150,
      cell: ({ row }) => <FileChip file={row.original} showExtension={true} />,
    },
    {
      accessorKey: "description",
      header: "Description",
      enableSorting: false,
      sortingFn: "alphanumeric",
      size: 300,
      cell: ({ row }) => row.original.file?.label,
    },
    {
      accessorKey: "actions",
      header: "",
      enableSorting: false,
      size: 72,
      cell: ({ row }) => (!isReadonly ? <PurchaseOrderFileRowActions row={row} onRemove={onRemove} /> : null),
    },
  ]
}
